export default __webpack_public_path__ + "static/media/f2.35906e3e.svg";